// src/pages/ManagementDashboard/ManagementDashboard.jsx
import { useParams, useSearchParams } from 'react-router-dom';
import { orgNavLinks } from '../../config/sidebarLinks';
import { useSelector } from 'react-redux';
import GroupsIsland from './ui/GroupsIsland/GroupIsland';
import OrganizationIsland from './ui/Organization/OrganizationIsland';
import DashboardLayout from '../../layouts/DashboardLayout';
import './ManagementDashboard.css';

export default function ManagementDashboard() {
  const { orgId } = useParams();
  const [searchParams] = useSearchParams();
  const userId = useSelector((s) => s.user?.data?.id)
  const orgIdNum = Number(orgId);
  const tab = searchParams.get('tab') || 'overview';

  const navLinks = orgNavLinks.map(link => ({
    ...link,
    to: link.to.replace(':orgId', orgId),
  }));

  return (
    <DashboardLayout navLinks={navLinks}>
      {tab === 'groups' && <GroupsIsland organizationId={orgIdNum}       currentUserId={userId}  />}
      {tab === 'organization' && <OrganizationIsland organizationId={orgIdNum}       me={userId}  />}
    </DashboardLayout>
  );
}
